import script from "./BookSelection20710.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookSelection20710.vue?vue&type=script&setup=true&lang=ts"

import "./BookSelection20710.vue?vue&type=style&index=0&id=dfe89542&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfe89542"]])

export default __exports__